import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const LoginSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // 1. Extract the token from the URL (e.g., ?token=eyJhbG...)
    const params = new URLSearchParams(location.search);
    const token = params.get("token");

    if (token) {
      // 2. Save the token to localStorage
      localStorage.setItem("token", token);
      
      // 3. Remove guestId since the user is now logged in
      localStorage.removeItem("guestId");

      // 4. Redirect to home page and force a reload to update the header
      window.location.href = "/";
    } else {
      // If no token is found, redirect back to login
      navigate("/login");
    }
  }, [navigate, location]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', flexDirection: 'column' }}>
      <h2>Authenticating...</h2>
      <p>Please wait while we log you in.</p>
    </div>
  );
};

export default LoginSuccess;